import React from 'react';
import { Modal } from 'react-bootstrap';
import { AiOutlineClose } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';

const RootRutModal = ({ show, onHide }) => {
  const { t } = useTranslation();

  return (
    <Modal size="lg" show={show} onHide={onHide}>
      <Modal.Header>
        <Modal.Title>{t('Root and square deductions')}</Modal.Title>
        <AiOutlineClose className="ml-auto cursor-pointer" size={24} onClick={onHide} />
      </Modal.Header>
      <Modal.Body>
        <p>{t('A person who hires you to do ROT')}</p>
        <p>{t('Who can use the deduction?')}</p>
        <p>{t('A buyer who was unlimitedly liable')}</p>
      </Modal.Body>
    </Modal>
  );
};

export default RootRutModal;